import type { LanguageSummary } from "features/languages/types";

export type UserRole = "Owner" | "Admin" | "Manager" | "Translator" | "Translator Junior";
export type UserRoleNums = 10 | 20 | 30 | 40 | 50;

export enum UserRoleEnum {
  "Owner" = 10,
  "Admin" = 20,
  "Manager" = 30,
  "Translator" = 40,
  "Translator Junior" = 50,
}

export interface User {
  id: string | null;
  email: string;
  name: string;
  role: UserRoleNums;
  languages?: LanguageSummary[];
}

export interface UserPUT extends Omit<User, "languages"> {
  languages: string[];
}

export interface UsersPage {
  list: User[];
  totalCount: number;
}

export type FormAction = "edit" | "create" | "read";
